import React from 'react';
import {a, useTransition} from 'react-spring';
import {useRouter} from '@hooks/useRouter';
import {useBus} from 'react-bus';

export const PageTransition = ({ children, ...props }) => {
  const bus = useBus();
  const router = useRouter();
  const transitions = useTransition(router, {
    keys: (item) => item.pathname,
    from: { transform: `translate3d(5%,0,0)`, position: 'absolute', width: '100%', opacity: 0 },
    enter: (item) => ({
      transform: `translate3d(0,0,0)`,
      position: 'relative',
      opacity: 1,
      onRest: () => bus.emit('onTransitionDone', item.pathname),
    }),
    leave: { transform: `translate3d(-5%,0,0)`, position: 'absolute', width: '100%', opacity: 0 },
  });

  return (
    <>
      <div>
        {transitions((style, item, _t, key) => {
          const { Component, props } = item.components[item.pathname] || {};
          return (
            <a.div
              key={key as any}
              // @ts-ignore
              style={style}
            >
              {children(item ? { Component, pageProps: props && props.pageProps } : {})}
            </a.div>
          );
        })}
      </div>
    </>
  );
};

export default PageTransition;
